import styled from '@emotion/styled/macro';
import { LayoutRow, Variables } from '@enter/core';

export const Wrapper = styled.div`
    padding: 48px;
    overflow-y: auto;
`;

export const StyledLayoutRow = styled(LayoutRow)`
    /* max-width: 1440px; */
`;

export const Info = styled.div`
    margin-top: 5px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: ${Variables.Colors.n70};
    fill: ${Variables.Colors.n70};
    > span {
        margin-left: 5px;
    }
`;
